import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireAdminOrManager?: boolean;
  requireAdminOrGeneralManager?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
  requireAdminOrManager = false,
  requireAdminOrGeneralManager = false
}) => {
  const { isAuthenticated, isLoading, isAdmin, isDepartmentManager, agent } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  if (requireAdminOrManager && !isAdmin() && !isDepartmentManager() && agent?.role !== 'GENERAL_MANAGER') {
    return <Navigate to="/" replace />;
  }

  if (requireAdminOrGeneralManager && !isAdmin() && agent?.role !== 'GENERAL_MANAGER') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
